<template>
  <el-form
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="分类名称" prop="name">
      <el-input
        class="middle_input"
        clearable
        maxlength="8"
        v-model="ruleForm.name"
        placeholder="请填写分类名称"
      />
    </el-form-item>
    <el-form-item label="所属上级分类" prop="superiorId" v-if="editId == 0">
      <el-select
        v-model="ruleForm.superiorId"
        class="m-2 middle_input"
        placeholder="请选择所属上级分类"
        size="large"
      >
        <el-option
          v-for="item in firstLevelList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="Tdk标题" prop="title">
      <el-input
        class="middle_input"
        clearable
        v-model="ruleForm.title"
        placeholder="请输入Tdk标题"
      />
    </el-form-item>
    <el-form-item label="Tdk关键字" prop="keywords">
      <el-col :span="24">
        <el-tag
          v-for="(item, index) in ruleForm.keywords"
          :key="item"
          closable
          @close="delTag(index, ruleForm.keywords)"
        >
          {{ item }}
        </el-tag>
      </el-col>
      <el-col v-if="ruleForm.keywords.length !== 6">
        <el-tooltip
          class="box-item"
          effect="dark"
          content="单个关键字2-8个字，关键字数目不能超过6个,便于搜索引擎收录页面"
          placement="top-start"
        >
          <el-input
            class="small_input"
            v-model="keyword"
            placeholder="请输入Tdk关键字"
            maxlength="8"
            clearable
          ></el-input>
        </el-tooltip>
        <el-button
          v-if="ruleForm.keywords.length !== 6"
          type="primary"
          @click="addTag(keyword, ruleForm.keywords)"
          plain
        >
          <el-icon> <Plus /> </el-icon>&nbsp;添加
        </el-button>
      </el-col>
    </el-form-item>

    <el-form-item label="Tdk描述" prop="desp">
      <el-tooltip
        class="box-item"
        effect="dark"
        content="描述主要用于该分类相应的前台文章列表页的页面描述,便于搜索引擎收录页面"
        placement="top-start"
      >
        <el-input
          v-model="ruleForm.desp"
          :rows="4"
          show-word-limit
          type="textarea"
          placeholder="请输入Tdk描述"
          maxlength="100"
        />
      </el-tooltip>
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
      :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import {
  getFirstLevel,
  getCategory,
  addCategory,
  modifyCategory,
} from "network/articleClassification.js";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "AddEditArticleClass",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      ruleForm: {
        name: "",
        title:"",
        superiorId: null,
        keywords: [],
        desp: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写分类名称" },
          { min: 2, max: 8, message: "分类名称为2-8字" },
        ],
        superiorId: [
          {
            required: true,
            message: "请选择所属上级分类",
          },
        ],
        // keywords: [
        //   {
        //     required: true,
        //     message: "请设置Tdk关键字",
        //     trigger: "change",
        //   },
        // ],
        // desp: [
        //   {
        //     required: true,
        //     message: "请填写Tdk描述",
        //   },
        //   { min: 2, max: 100, message: "Tdk描述为2-100字" },
        // ],
      },
      keyword: "", //关键字
      firstLevelList: [], //上级分类
      submitDisabled:false,
    });
    onMounted(() => {
      //编辑-获取详情
      if (props.editId > 0) {
        getCategory(props.editId).then((result) => {
          if (result && result.code == 1) {
            data.ruleForm = result.result;
          } else {
            ElMessage.error(result.message);
          }
        });
      }
      getLevelClass(); //获取上级分类
    });
    function getLevelClass() {
      getFirstLevel().then((res) => {
        if (res.code == 1) {
          data.firstLevelList = res.result;
          data.firstLevelList.push(
            { id: 0, name: '无' }
          )
        } else {
          ElMessage.error(res.message);
        }
      });
    }

    //添加关键字
    const addTag = (val, valAll) => {
      if (val == "" || val == null || val.length < 2) {
        ElMessage.error("请输入2-8个字");
        return false;
      }
      if (valAll.length >= 6) {
        data.keyword = "";
        ElMessage.error("最多只能设置6个");
        return false;
      }
      var index = valAll.indexOf(val);
      if (index >= 0) {
        ElMessage.error("关键字[" + val + "]已存在");
        return false;
      }
      valAll.push(val);
      data.ruleForm.keywords = valAll;
      ElMessage({ message: "添加成功！", type: "success" });
      data.keyword = "";
    };
    //删除关键字
    const delTag = (index, valAll) => {
      valAll.splice(index, 1);
      ElMessage({ message: "删除成功！", type: "success" });
    };

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
         data.submitDisabled = true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    async function updataAdd() {
            let result;
      if (props.editId > 0) {
        data.ruleForm.id = props.editId;
        result = await modifyCategory(data.ruleForm);
      } else {
        result = await addCategory(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                 });
            emit("close-dialog");
            emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };
    return {
      ...toRefs(data),
      addTag,
      delTag,
      submitForm,
      ruleFormRef,
      resetForm,
    };
  },
};
</script>
<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 450px;
}
</style>

